

export const GOOGLE_CALENDAR_URL = "https://calendar.app.google/B2T7t36czEGmbFgr6";
export const CALENDAR_URL = "/see-you-on-a-call";

export const getHomePagePath = () => "/";

export const getTeamPagePath = () => "/team";

export const getProjectsPagePath = () => "/projects";

export const getServicesPagePath = () => "/services";

export const getContactsPagePath = () => "/contacts";

export const getBlogPagePath = () => "/blog";

export const getDedicatedDevelopersPagePath = () => "/services/dedicated-developers";

export const getBusinessAutomationPagePath = () => "/services/business-process-automation";

export const getRecruitmentWebsitesPagePath = () => "/services/websites-for-recruitment-agencies";

export const getMobileAppDevelopmentPagePath = () => "/services/ios-android-app-development";

export const getConstructionWebsitesPagePath = () => "/services/websites-for-construction-companies";

export const getProductsPagePath = () => "/products";
